import { ErrorMessage } from "@hookform/error-message";
import * as moment from "moment";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  UncontrolledDropdown,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row,
} from "../../components/Component";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import Table from "../../components/react-table/Table";
import { DELETE, GET, POST, PUT } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import { useHistory, useLocation } from 'react-router-dom';
const DEFAULT_HOLIDAY = {
  id: "",
  name: "",
  startDate: "",
  endDate: "",
};

const DISPLAY_DATE_FORMAT = "DD/MM/YYYY";

const HolidayManager = () => {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [view, setView] = useState({
    edit: false,
    add: false,
    details: false,
    isDelete: false,
  });
  const { errors, register, handleSubmit, reset, getValues } = useForm({
    defaultValues: DEFAULT_HOLIDAY,
  });
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const [editId, setEditedId] = useState();
  const [deleteId, setDeleteId] = useState();
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [rangeDate, setRangeDate] = useState({
    start: searchParams.get('start') ? moment(searchParams.get('start')).startOf('days').toDate() : moment().startOf("years").toDate(),
    end: searchParams.get('end') ? moment(searchParams.get('end')).endOf('days').toDate() : moment().add(1, 'years').endOf("years").toDate(),
  });

  const colTable = [
    {
      Header: "Tên ngày nghỉ",
      accessor: "name",
    },
    {
      Header: "Ngày bắt đầu",
      accessor: (item) => moment(item.startDate).format(DISPLAY_DATE_FORMAT),
    },
    {
      Header: "Ngày kết thúc",
      accessor: (item) => moment(item.endDate).format(DISPLAY_DATE_FORMAT),
    },
    {
      Header: "Hành động",
      accessor: (item) => (
        <ul className="nk-tb-actions gx-1">
          <li>
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                className="btn btn-icon dropdown-toggle btn-trigger"
              >
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu right>
                <ul className="link-list-opt no-bdr">
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        onEditClick(item.id);
                        toggle("edit");
                      }}
                    >
                      <Icon name="edit" className="text-danger"></Icon>
                      <span>Sửa</span>
                    </DropdownItem>
                  </li>
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setDeleteId(item.id);
                        toggle("isDelete");
                      }}
                    >
                      <Icon name="trash" className="text-danger"></Icon>
                      <span>Xoá</span>
                    </DropdownItem>
                  </li>
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul>
      ),
    },
  ];

  // Changing state value when searching name
  useEffect(() => {
    const newParams = new URLSearchParams({
      ...rangeDate,
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })

    setLoading(true);
    setData([]);
    let params = {
      startDate: moment(rangeDate.start).format('YYYY-MM-DD'),
      endDate: moment(rangeDate.end).format('YYYY-MM-DD'),
    };

    GET(`holiday`, params, true)
      .then(({ data }) => {
        setData([...data?.rows]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [timeNow]);

  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  const onEditClick = (id, type = "") => {
    setLoading(true);
    setEditedId(id);

    GET(`holiday/${id}`, {}, true)
      .then(({ data }) => {
        reset({
          ...data,
        });
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
        onFormCancel();

      })
      .finally(() => {
        setLoading(false);
      });
  };

  const resetData = () => {
    setEditedId("");
    onFormCancel();
    setTimeNow(moment().valueOf());
  };

  // Submits form data
  const onHandleSubmit = () => {
    setLoading(true);
    const { id, endDate, name, startDate } = getValues();

    if (moment(endDate).isBefore(moment(startDate), "date")) {
      return toast.error("Ngày kết thúc phải lớn hoặc bằng ngày bắt đầu");
    }

    const formData = {
      endDate,
      name,
      startDate,
    };

    const request = editId
      ? PUT(`holiday/${editId}`, formData, {}, true)
      : POST("holiday", formData, {}, true);

    request
      .then((res) => {
        if (editId) {
          toast.success("Cập nhật thành công");
        } else {
          toast.success("Thêm thành công");
        }
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ add: false, edit: false, isDelete: false });
    reset(DEFAULT_HOLIDAY);
    setEditedId();
    setDeleteId();
  };

  const deleteOrder = (id) => {
    if (!id) {
      return;
    }
    DELETE(`holiday/${id}`, {}, true)
      .then((res) => {
        toast.success("Xóa ngày lễ tải thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  const onRangeChange = (dates) => {
    const [start, end] = dates;
    setRangeDate({ start: start ? moment(start)?.startOf('days').toDate() : start, end: end ? moment(end)?.endOf('days').toDate() : end });
    if (start && end) {
      setTimeNow(moment().valueOf());
    }
  };

  return (
    <React.Fragment>
      <Head title="Quản lý ngày lễ"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Ngày lễ</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <DatePicker
                          onKeyDown={(e) => {
                            e.preventDefault();
                          }}
                          placeholderText="Lọc theo ngày"

                          selected={rangeDate.start}
                          startDate={rangeDate.start}
                          endDate={rangeDate.end}
                          onChange={onRangeChange}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>
                    <li>
                      <div>
                        <Button
                          className="btn-primary"
                          color="primary"
                          onClick={() => {
                            resetData();
                            toggle("add");
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Thêm ngày lễ</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3">
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>

        <Modal
          isOpen={view.add || view.edit}
          toggle={() => onFormCancel()}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a href="#cancel" className="close">
              {" "}
              <Icon
                name="cross-sm"
                onClick={(ev) => {
                  ev.preventDefault();
                  onFormCancel();
                }}
              ></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">{editId ? "Sửa" : "Thêm"} ngày lễ</h5>
              <div className="mt-4">
                <form onSubmit={handleSubmit(onHandleSubmit)}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Tên ngày lễ <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            ref={register({
                              required: "Vui lòng nhập thông tin",
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="name"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Ngày bắt đầu <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="date"
                            className="form-control"
                            name="startDate"
                            ref={register({
                              required: "Vui lòng nhập thông tin",
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="startDate"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Ngày kết thúc <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="date"
                            className="form-control"
                            name="endDate"
                            ref={register({
                              required: "Vui lòng nhập thông tin",
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="endDate"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col size="12">
                      <Button color="primary" type="submit">
                        <Icon className="plus"></Icon>
                        <span>{editId ? "Sửa" : "Thêm"} ngày lễ</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={view.isDelete} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá ngày lễ này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    deleteOrder(deleteId);
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default HolidayManager;
